module.exports = __webpack_public_path__ + "static/WEDDING E&M-369-733f0b7746c1ffba2f74689a0c7be334.jpg";